import { LucideLogOut } from 'lucide-react'
import styles from './UserSettings.module.css'
import { useNavigate, useRevalidator } from 'react-router'
import { authClient } from '@/lib/auth-client'
import { useEffect, useRef } from 'react'

type Props = {    
    isActive: boolean
    onBlur: () => void
}

export default function UserSettings({isActive, onBlur} : Props) {
    const navigate = useNavigate()
    const {revalidate} = useRevalidator()
    const handleLogout = async () => {    
        const res = await authClient.signOut()
        onBlur()
        revalidate();
        if (res.data?.success) await navigate("/")        
    }

    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {        
        const listener = (e: MouseEvent) => {
            if(ref.current && !ref.current.contains(e.target as Node)) {
                onBlur()
            }
        }

        document.addEventListener("mousedown", listener)
        return () => document.removeEventListener("mousedown",listener)
    }, [onBlur])


    return (        
        <div onClick={(e) => e.stopPropagation()} ref={ref} className={`${styles.container} ${!isActive ? styles.hidden : ""}`}>
            <div className={styles.card} onClick={handleLogout}>
                <LucideLogOut />
                <span>Cerrar sesión</span>
            </div>
        </div>        
    )
}
